module.exports = __webpack_public_path__ + "773bc2df9b758a35d216002d31c9032f.MP3";